

























import VueOptions from '@utils/VueOptions'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'ShoppingCartLineItemResourceList'

  vue:
    props: ['lineItems', 'options', 'actions', 'infiniteWrapper']

    components: {
      ResourceList,
      LoadingIndicator,
    }

    data: ->
      isAllSelected: false
      selectedLineItems: []
      nextPage: 1
      target:
        q: ''

    computed:
      components: ->
        'shopping-cart-item-card': () => import('@ui/cards/ShoppingCartItemCard')

      resourceKey: -> @options?.resourceKey || 'line_items'

      listItemActions: ->
        @actions

    methods:
      hiApplyFilters: ->
        @$refs.infiniteLoading.stateChanger.reset()
        @nextPage = 1
        @actions.fetchResource null, @resourceKey, @target, { page: @nextPage }
        @nextPage += 1

      hiSearchChange: ->

      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @targetPayload(), { page: @nextPage })
        @nextPage += 1

      targetPayload: -> {}

export default VueOptions.vue settings
